module.exports = __webpack_public_path__ + "img/l_Jest.b75677c3.svg";